import React from "react";

import Chip from "@busbud/design-system-components/dist/Chip";
import Heading from "@busbud/design-system-components/dist/Heading";
import Shield from "@busbud/design-system-components/dist/Icons/Shield/LG";
import Label from "@busbud/design-system-components/dist/Label";
import Stack from "@busbud/design-system-components/dist/Stack/Stack";

import { useAppContext } from "@app/helpers/hooks";

import { DefaultMessage } from "./default-message";
import { useStyles } from "./hepstar-banner.styles";

interface Props {
  is_displayed: boolean;
  title?: React.ReactNode;
  message?: React.ReactNode;
  direction?: "row" | "column";
  footer?: React.ReactNode;
  classes?: {
    root?: string;
  };
}

export const HepstarBannerChip: React.FC<Props> = ({
  is_displayed,
  direction = "row",
  title: chip_title,
  message: chip_message,
  classes: external_classes,
  footer
}) => {
  const { translator } = useAppContext();
  const is_row = direction === "row";
  const title = chip_title || translator.t("!ancillary.hepstar-banner.title");

  const {
    classes,
    theme: { spacing }
  } = useStyles();

  const message = chip_message || <DefaultMessage />;

  if (!is_displayed) {
    return null;
  }

  return (
    <Chip
      className={classes.chip}
      classes={{
        root: external_classes?.root
      }}
      style={{
        padding: spacing(is_row ? 2 : 3, is_row ? 2.5 : 3.5),
        textAlign: is_row ? "left" : "center"
      }}
      color="blue"
      variant="subtle"
      label={
        <>
          <Stack
            spacing={{
              xs: 2,
              md: 0.5
            }}
            display="flex"
            alignItems="center"
            direction={direction}
            width="100%"
          >
            <Shield className={classes.icon} width={60} height={64} />
            <Stack spacing={is_row ? 0 : 1} direction="column">
              <Heading
                size={is_row ? "xs" : "sm"}
                style={{
                  textAlign: is_row ? "start" : "center"
                }}
              >
                {title}
              </Heading>
              <Label size="md" className={classes.subtext}>
                {message}
              </Label>
            </Stack>
          </Stack>
          {!!footer && <div className={classes.footer}>{footer}</div>}
        </>
      }
    ></Chip>
  );
};
